import React from 'react';
import { AVAILABLE_CONTRIBUTION_TIP_TEXT } from '../../../../settings/settings';
import './IRAContributionsAvailableTip.scss';

const IRAContributionsAvailableTip = () => (
  <div className="available-contribution-tip">
    <p>{AVAILABLE_CONTRIBUTION_TIP_TEXT}</p>
    <p className="available-contribution-para">
      You cannot contribute more than your earned income for the year.
    </p>
  </div>
);

export default IRAContributionsAvailableTip;
